/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Picker_One_Night_SelectedInputs */

const en_picker_one_night_selected = /** @type {(inputs: Picker_One_Night_SelectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1 night selected`)
};

/**
* | output |
* | --- |
* | "1 night selected" |
*
* @param {Picker_One_Night_SelectedInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const picker_one_night_selected = /** @type {((inputs?: Picker_One_Night_SelectedInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Picker_One_Night_SelectedInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_picker_one_night_selected(inputs)
});